import { createReducer, on } from "@ngrx/store";
import {
  OrganisationState,
  initialOrganisationState,
} from "./organisation.state";
import {
  ClearAvailability,
  ClearCrudOrganisationState,
  ClearEditOrganisationState,
  CreateOrganisation,
  CreateOrganisationError,
  CreateOrganisationSuccess,
  DeleteOrganisation,
  DeleteOrganisationError,
  DeleteOrganisationSuccess,
  EditOrganisation,
  EditOrganisationError,
  EditOrganisationSuccess,
  GetIsOrganisationDeletable,
  GetIsOrganisationDeletableError,
  GetIsOrganisationDeletableSuccess,
  GetOrganisationDetails,
  GetOrganisationDetailsError,
  GetOrganisationDetailsSuccess,
  GetOrganisationList,
  GetOrganisationListError,
  GetOrganisationListSuccess,
  GetOrganisationPermissions,
  GetOrganisationPermissionsError,
  GetOrganisationPermissionsSuccess,
  GetOrganisationTable,
  GetOrganisationTableError,
  GetOrganisationTableLength,
  GetOrganisationTableLengthError,
  GetOrganisationTableLengthSuccess,
  GetOrganisationTableSuccess,
  IsAvailableOrgName,
  IsAvailableOrgNameError,
  IsAvailableOrgNameInvalid,
  IsAvailableOrgNameSuccess,
  RemoveItemsFromOrganisationList,
  ResetOrganisationState,
  ResetOrganisationTable,
  ResetOrganisationTableError,
  ResetOrganisationTableSuccess,
  ResetOrganisationTableUnload,
  UpdateOrganisationTable,
  UpdateOrganisationTableError,
  UpdateOrganisationTableSuccess,
} from "./organisation.actions";

export const OrganisationReducers = createReducer(
    initialOrganisationState,
    on(GetOrganisationList, (state): OrganisationState => {
        return {
            ...state,
            loading: true,
            error: false,
        };
    }),
    on(GetOrganisationListSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            list: action.list.slice().sort((a, b) => a.name.localeCompare(b.name)),
        };
    }),
    on(GetOrganisationListError, (state): OrganisationState => {
        return {
            ...state,
            loading: false,
            error: true,
        };
    }),
    on(UpdateOrganisationTable, (state): OrganisationState => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(UpdateOrganisationTableSuccess, (state): OrganisationState => {
        return {
            ...state,
            loading: false,
        };
    }),
    on(UpdateOrganisationTableError, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    }),
    on(GetOrganisationTable, (state): OrganisationState => {
        return {
            ...state,
            loading: true,
            isGetTableOverallLength: false,
        };
    }),
    on(GetOrganisationTableSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            organisationRecords: action.result,
            isGetTableOverallLength: action.isGetLength,
        };
    }),
    on(GetOrganisationTableError, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            error: action.error,
            isGetTableOverallLength: false,
        };
    }),
    on(GetOrganisationTableLength, (state): OrganisationState => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(GetOrganisationTableLengthSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            organisationRecordsLength: action.result,
        };
    }),
    on(GetOrganisationTableLengthError, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    }),
    on(ResetOrganisationTable, (state): OrganisationState => {
        return {
            ...state,
            loading: true,
            isInitialLoadFlowReset: false,
        };
    }),
    on(ResetOrganisationTableSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            isInitialLoadFlowReset: action.isInitialLoad,
        };
    }),
    on(ResetOrganisationTableError, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            error: action.error,
            isInitialLoadFlowReset: false,
        };
    }),
    on(ResetOrganisationTableUnload, (state): OrganisationState => {
        return {
            ...state,
            organisationRecords: [],
        };
    }),
    on(CreateOrganisation, (state, action): OrganisationState => {
        return {
            ...state,
            crudData: action.organisationDto,
            crudLoader: true,
            crudError: null,
            crudResult: null,
        };
    }),
    on(CreateOrganisationSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            crudLoader: false,
            crudResult: action.result,
        };
    }),
    on(CreateOrganisationError, (state, action): OrganisationState => {
        return {
            ...state,
            crudLoader: false,
            crudError: action.error,
        };
    }),
    on(IsAvailableOrgName, (state): OrganisationState => {
        return {
            ...state,
            orgNameLoader: true,
            validOrgName: null,
            orgNameError: null,
        };
    }),
    on(IsAvailableOrgNameSuccess, (state): OrganisationState => {
        return {
            ...state,
            orgNameLoader: false,
            validOrgName: true,
        };
    }),
    on(IsAvailableOrgNameInvalid, (state): OrganisationState => {
        return {
            ...state,
            orgNameLoader: false,
            validOrgName: false,
        };
    }),
    on(IsAvailableOrgNameError, (state, action): OrganisationState => {
        return {
            ...state,
            orgNameLoader: false,
            validOrgName: false,
            orgNameError: action.error,
        };
    }),
    on(ClearCrudOrganisationState, (state): OrganisationState => {
        return {
            ...state,
            crudData: null,
            crudError: null,
            crudLoader: false,
            crudResult: null,
        };
    }),
    on(ClearAvailability, (state): OrganisationState => {
        return {
            ...state,
            validOrgName: null,
            orgNameError: null,
            orgNameLoader: false,
        };
    }),
    on(GetOrganisationDetails, (state): OrganisationState => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(GetOrganisationDetailsSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            organisationDetails: action.result,
        };
    }),
    on(GetOrganisationDetailsError, (state, action): OrganisationState => {
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    }),
    on(ClearEditOrganisationState, (state): OrganisationState => {
        return {
            ...state,
            editOrgData: null,
            crudError: null,
            crudLoader: false,
            crudResult: null,
        };
    }),
    on(EditOrganisation, (state, action): OrganisationState => {
        return {
            ...state,
            editOrgData: action.editOrganisationDto,
            crudLoader: true,
            crudError: null,
            crudResult: null,
        };
    }),
    on(EditOrganisationSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            crudLoader: false,
            crudResult: action.result,
        };
    }),
    on(EditOrganisationError, (state, action): OrganisationState => {
        return {
            ...state,
            crudLoader: false,
            crudError: action.error,
        };
    }),
    on(RemoveItemsFromOrganisationList, (state): OrganisationState => {
        return {
            ...state,
        };
    }),
    on(GetOrganisationPermissions, (state): OrganisationState => {
        return {
            ...state,
            crudLoader: true,
            crudError: null,
            crudResult: null,
            organisationPermissions: null,
        };
    }),
    on(GetOrganisationPermissionsSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            crudLoader: false,
            organisationPermissions: action.list,
        };
    }),
    on(GetOrganisationPermissionsError, (state, action): OrganisationState => {
        return {
            ...state,
            crudLoader: false,
            crudError: action.error
        };
    }),
    on(GetIsOrganisationDeletable, (state): OrganisationState => {
        return {
            ...state,
            isOrgDeletable: null,
            isOrgDeletableLoader: true,
            isOrgDeletableError: null
        };
    }),
    on(GetIsOrganisationDeletableSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            isOrgDeletable: action.result,
            isOrgDeletableLoader: false
        };
    }),
    on(GetIsOrganisationDeletableError, (state, action): OrganisationState => {
        return {
            ...state,
            isOrgDeletableError: action.error,
            isOrgDeletableLoader: false
        };
    }),
    on(DeleteOrganisation, (state): OrganisationState => {
        return {
            ...state,
            deleteOrganisationLoader: true,
            deleteOrganisationResult: null,
            deleteOrganisationError: null
        };
    }),
    on(DeleteOrganisationSuccess, (state, action): OrganisationState => {
        return {
            ...state,
            deleteOrganisationLoader: false,
            deleteOrganisationResult: action.result
        };
    }),
    on(DeleteOrganisationError, (state, action): OrganisationState => {
        return {
            ...state,
            deleteOrganisationLoader: false,
            deleteOrganisationError: action.error
        };
    }),
    on(ResetOrganisationState, (): OrganisationState => {
        return initialOrganisationState;
    })

);